// @dev: replace this value with the name of the widget you're building
//       (ex: m-widget-connect, m-burn-redeem-complete, etc.)
export const DATA_WIDGET_VALUE = 'm-campaign';

// common events
export const AUTHENTICATED = 'm-authenticated';
export const UNAUTHENTICATED = 'm-unauthenticated';
